// Current age bracket of an animal, derived from its birth date (year and month,
// 'YYYY-MM') and the age intervals of its species (AnimalType.ageIntervals).
// An interval covers minAge <= age < maxAge (in full years); an empty bound is open.

const isBound = value => typeof value === 'number'

const BIRTH_DATE_PATTERN = /^(\d{4})-(0[1-9]|1[0-2])$/

// {year, month} of a 'YYYY-MM' birth date, null when missing or malformed
export function parseBirthDate(birthDate) {
    const match = typeof birthDate === 'string' && birthDate.match(BIRTH_DATE_PATTERN)
    return match ? {year: Number(match[1]), month: Number(match[2])} : null
}

export function isFutureBirthDate(birthDate, now = new Date()) {
    const parsed = parseBirthDate(birthDate)
    return !!parsed && parsed.year * 12 + parsed.month > now.getFullYear() * 12 + now.getMonth() + 1
}

// Age in full years: the birthday is reached at the start of the birth month
export function animalAge(birthDate, now = new Date()) {
    const parsed = parseBirthDate(birthDate)
    if (!parsed) return null
    const months = (now.getFullYear() - parsed.year) * 12 + (now.getMonth() + 1 - parsed.month)
    return Math.floor(months / 12)
}

export function findAgeInterval(birthDate, ageIntervals, now = new Date()) {
    const age = animalAge(birthDate, now)
    if (age === null || age < 0) return null
    return (ageIntervals || []).find(interval => interval
        && (!isBound(interval.minAge) || age >= interval.minAge)
        && (!isBound(interval.maxAge) || age < interval.maxAge)
    ) || null
}

export function ageIntervalLabel(interval) {
    if (!interval) return null
    const min = isBound(interval.minAge) ? interval.minAge : null
    const max = isBound(interval.maxAge) ? interval.maxAge : null
    const years = n => `${n} an${n > 1 ? 's' : ''}`
    if (min === null && max === null) return null
    if (max === null) return `${years(min)} et plus`
    if (min === null || min === 0) return `moins de ${years(max)}`
    return `${min} à ${years(max)}`
}
